import React from "react";
import styles from "../Carousel.module.css";

const {
  carouselHeader,
  carouselNavigation,
  highlight,
  carouselSubtitle,
  headerArrows,
} = styles;

export const Header = ({
  title,
  enhancedSubtitle,
  subtitleHtmlTag: SubtitleTag = "span",
  children,
  lockedNext,
  lockedPrev,
}: {
  title?: string;
  enhancedSubtitle?: string;
  subtitleHtmlTag?: keyof JSX.IntrinsicElements;
  children?: React.ReactNode;
  lockedNext?: boolean;
  lockedPrev?: boolean;
}) => {
  return (
    <div className={carouselHeader}>
      <div className={carouselNavigation}>
        {title && <h2>{title}</h2>}
        <div
          className={headerArrows}
          data-locked-next={lockedNext}
          data-locked-prev={lockedPrev}
          role="group"
          aria-label="Carousel navigation arrows"
        >
          {children}
        </div>
      </div>
      <div className={carouselSubtitle}>
        {enhancedSubtitle && (
          <SubtitleTag
            className={highlight}
            dangerouslySetInnerHTML={{ __html: enhancedSubtitle }}
          />
        )}
      </div>
    </div>
  );
};
